<template>
  <v-card flat class="" color="backgroundShade">
    <v-date-input
      color="accent"
      label="vrs. Projektabschluss"
      v-model="date"
      bg-color="background"
      :readonly="!admin"
      hide-details
      variant="solo"
      prepend-icon=""
      class="mb-3"
      flat
      @blur="updateDate"
    ></v-date-input>
    <v-textarea
      @change="updateDescription"
      v-model="description"
      hide-details
      flat
      bg-color="background"
      color="accent"
      rows="3"
      max-rows="5"
      auto-grow
      label="Projektbeschreibung"
      :readonly="!admin"
      class="border-background"
      variant="solo"
    ></v-textarea
  ></v-card>
</template>

<script>
import ApiService from "@/services/api.service";

export default {
  name: "ProjectInfoItem",
  data() {
    return {
      date: null,
      description: "",
    };
  },
  props: {
    admin: Boolean,
    projectId: Number,
  },
  methods: {
    async updateDate() {
      try {
        const response = await ApiService.post(
          `project/${this.projectId}/update/estimatedProjectEnd`,
          { date: this.date }
        );
        console.log("Date Update", response);
      } catch (e) {
        console.log("Error", e);
      }
    },
    async updateDescription() {
      try {
        const response = await ApiService.post(
          `project/${this.projectId}/update/description`,
          { text: this.description }
        );
        console.log("Description Update", response);
      } catch (e) {
        console.log("Error", e);
      }
    },
  },
};
</script>

<style scoped>
/* remove shadow from v-date-picker */
.v-textarea {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
}
</style>
